// extracted by mini-css-extract-plugin
module.exports = {"car":"Car_car__2Mz3u","active":"Car_active__3xyMu","pulse":"Car_pulse__1WUUf"};